import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FieldAnswerFeedback } from '../../ui/field-answer-feedback/field-answer-feedback';
import { FIELD_TYPES } from '../../constants';
import { shuffle } from 'lodash';
import { CheckboxGroupComponent } from '../../ui/checkbox-group/checkbox-group';
import FieldWrapper from '../../ui/field-wrapper';
// TODO pass required to TPA component after contribution
const QuizMultiChoice = props => {
  const {
    target,
    externalData,
    options,
    randomizeChoices
  } = props;
  const sortedOptions = useMemo(() => randomizeChoices ? shuffle(options) : options, [options, randomizeChoices]);
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: FIELD_TYPES.QUIZ_MULTI_CHOICE,
    dataHook: target
  }, /*#__PURE__*/React.createElement(CheckboxGroupComponent, _extends({}, props, {
    options: sortedOptions,
    hideLabel: false,
    required: false,
    fieldType: FIELD_TYPES.QUIZ_MULTI_CHOICE
  })), /*#__PURE__*/React.createElement(FieldAnswerFeedback, {
    target: target,
    externalData: externalData
  }));
};
export default QuizMultiChoice;
//# sourceMappingURL=quiz-multi-choice.js.map